import type { JSX , MouseEventHandler } from "react";
import type { NavItemMenuProps } from "./nav-item-menu";
import { ClickAwayListener, Grow, MenuList, Paper, Popper, css, styled } from "@mui/material";
import { useState } from "react";
import { NavButton } from "../nav-button";
import { SingleNavItem } from "../nav-item"; // eslint-disable-line import/no-cycle
import { useNavItemActive } from "../use-nav-item-active";


const TRANSITION_STYLE = { transformOrigin: "top" } as const;

const NavMenuPaper = styled(Paper)(({ theme }) => css`
	background-color: ${theme.palette.dark.main};
	color: ${theme.palette.dark.contrastText};

	border-top-left-radius: 0;
	border-top-right-radius: 0;
	overflow: hidden;

	.MuiList-root {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		padding: 0;

		li {
			display: grid;
		}
	}
	
	.popupMenuRoot {
		z-index: ${theme.zIndex.appBar + 1};
	}
`);

const NavMenuPopper = styled(Popper)(({ theme }) => css`
	z-index: ${theme.zIndex.appBar- 1};
`);

export const NavItemMenuCollapsed = (item: NavItemMenuProps): JSX.Element => {
	const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>(null);
	const menuOpen = !!anchorEl;

	const active = useNavItemActive(item);

	const handleClick: MouseEventHandler<HTMLButtonElement> = ev => {
		setAnchorEl(ev.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const buttonId = item.labelKey + "Button";
	const menuId = item.labelKey + "Menu";

	return (
		<>
			<NavButton
				id={ buttonId }
				labelKey={ item.labelKey }
				icon={ item.icon }
				aria-controls={ menuOpen ? menuId : undefined }
				aria-haspopup="true"
				aria-expanded={ menuOpen ? "true" : undefined }
				onClick={ handleClick }
				slim={ item.slim }
				active={ active }
			/>
			<NavMenuPopper
				id={ menuId }
				className="popupMenuRoot"
				anchorEl={ anchorEl }
				open={ menuOpen }
				placement="bottom"
				transition
			>
				{
					({ TransitionProps }) => (
						<Grow { ...TransitionProps } style={ TRANSITION_STYLE }>
							<NavMenuPaper onClickCapture={ handleClose }>
								<ClickAwayListener onClickAway={ handleClose }>
									<MenuList aria-labelledby={ buttonId }>
										{ item.items.map(i => (
											<li key={ i.labelKey }>
												<SingleNavItem { ...i }/>
											</li>
										)) }
									</MenuList>
								</ClickAwayListener>
							</NavMenuPaper>
						</Grow>
					)
				}
			</NavMenuPopper>
		</>
	);
};
